module.exports = {
  schema: {
    name: '存貨單元',
    type: 'Object',
    contents: {
      productRef: {
        type: 'ObjectId',
        reference: 'products',
        name: '商品',
        refKeys: ['name'],
        input: 'select',
      },
      barcode: {
        type: 'String',
        name: '條碼',
      },
      origin: {
        type: 'String',
        name: '產地',
      },
      color: {
        type: 'String',
        name: '顏色',
      },
      model: {
        type: 'String',
        name: '型號',
      },
      size: {
        type: 'String',
        name: '尺寸',
      },
      material: {
        type: 'String',
        name: '材質',
      },
      contour: {
        type: 'String',
        name: '外型',
      },
      colorCode: {
        type: 'String',
        name: '色號',
      },
      length: {
        type: 'String',
        name: '腳長',
      },
      sphereMax: {
        type: 'String',
        name: 'S',
      },
      sphereMin: {
        type: 'String',
        name: 'S~',
      },
      refractiveIndex: {
        type: 'String',
        name: '折射率',
      },
      storageType: {
        type: 'String',
        name: '庫存/訂製',
      },
      cylinderMax: {
        type: 'String',
        name: 'C',
      },
      cylinderMin: {
        type: 'String',
        name: 'C~',
      },
      design: {
        type: 'String',
        name: '設計',
      },
      progressive: {
        type: 'String',
        name: '累進帶',
      },
      addMax: {
        type: 'String',
        name: 'A',
      },
      addMin: {
        type: 'String',
        name: 'A~',
      },
      coating: {
        type: 'String',
        name: '多層膜',
      },
      SCMax: {
        type: 'String',
        name: 'S+C',
      },
      SCMin: {
        type: 'String',
        name: 'S+C~',
      },
      diameter: {
        type: 'String',
        name: '直徑',
      },
      ultraviolet: {
        type: 'String',
        name: 'UV',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'productRef', width: 100 },
        { key: 'barcode', width: 130 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '存貨單元',
          rows: [
            [{ key: 'productRef' }],
            [{ key: 'barcode' }],
          ],
        },
        {
          name: '規格A',
          rows: [
            [{ key: 'color' }],
            [{ key: 'origin' }],
            [{ key: 'material' }],
            [{ key: 'size' }],
            [{ key: 'contour' }],
          ],
        },
        {
          name: '規格B',
          rows: [
            [{ key: 'sphereMax' }],
            [{ key: 'sphereMin' }],
            [{ key: 'refractiveIndex' }],
            [{ key: 'storageType' }],
            [{ key: 'cylinderMax' }],
            [{ key: 'cylinderMin' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/skus.js